import { NewsArticle, NewsOrder, NewsRanking } from './types';

type OrderingFacts = {
  id: number | string;
  timestamp?: string | null;
  ranking?: NewsRanking;
  score?: number;
};
const importanceRank = (item: OrderingFacts) =>
  typeof item.ranking?.importance_rank === 'number' &&
  item.ranking.importance_rank > 0
    ? item.ranking.importance_rank
    : Infinity;
const relevance = (item: OrderingFacts) =>
  item.ranking?.score ?? item.score ?? item.ranking?.relevance ?? -Infinity;

export const orderEvidence = <T>(
  items: T[],
  order: NewsOrder,
  facts: (item: T) => OrderingFacts,
): T[] =>
  [...items].sort((left, right) => {
    const a = facts(left);
    const b = facts(right);
    if (order === 'importance') {
      const rankDifference = importanceRank(a) - importanceRank(b);
      if (rankDifference && !Number.isNaN(rankDifference))
        return rankDifference;
      if (!Number.isFinite(importanceRank(a))) {
        const scoreDifference = relevance(b) - relevance(a);
        if (scoreDifference && !Number.isNaN(scoreDifference))
          return scoreDifference;
      }
    }
    const aTime = a.timestamp ? Date.parse(a.timestamp) : NaN;
    const bTime = b.timestamp ? Date.parse(b.timestamp) : NaN;
    if (Number.isFinite(aTime) !== Number.isFinite(bTime))
      return Number.isFinite(aTime) ? -1 : 1;
    if (Number.isFinite(aTime) && aTime !== bTime)
      return (aTime - bTime) * (order === 'newest' ? -1 : 1);
    return String(a.id).localeCompare(String(b.id), undefined, {
      numeric: true,
    });
  });

export const orderNews = (items: NewsArticle[], order: NewsOrder) =>
  orderEvidence(items, order, item => item);
